<button type="button" class="menu-button" (click)="clickEvent($event)"
  [attr.aria-label]="open ? 'Close navigation menu' : 'Open navigation menu'"
  [attr.aria-expanded]="open">
  <svg class="menu" viewBox="0 0 120 120" aria-hidden="true">
          <g>
            <path class="line top" d="M35,35h50c14.1,0,50.6,13,20.5,53.5s-121.9,21.6-94.4-40.3S111.6,8.4,85,35L35,85"/>
            <path class="line bottom" d="M35,85h50c14.1,0,50.6-13,20.5-53.5S-16.4,9.9,11.1,71.8S111.6,111.6,85,85L35,35"/>
            <line class="line cross" x1="35" y1="60" x2="85" y2="60"/>
          </g>
  </svg>
  <img class="brand-logo" src="assets/images/earthscoutIcon.PNG" alt="EarthScout" width="32" height="32" />
  <span class="brand-name">ROOTS</span>
</button>
